import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Catalog from "@/pages/Catalog";
import VerifyPortal from "@/pages/VerifyPortal";

import DashboardLayout from "@/components/layout/DashboardLayout";

import StudentOverview from "@/pages/student/StudentOverview";
import StudentCourses from "@/pages/student/StudentCourses";
import StudentCertificates from "@/pages/student/StudentCertificates";
import WalletPage from "@/pages/student/WalletPage";
import TutorPage from "@/pages/student/TutorPage";
import LessonPlayer from "@/pages/student/LessonPlayer";
import RewardsPage from "@/pages/student/RewardsPage";
import LeaderboardPage from "@/pages/student/LeaderboardPage";
import StorePage from "@/pages/StorePage";

import TeacherOverview from "@/pages/teacher/TeacherOverview";
import Gradebook from "@/pages/teacher/Gradebook";

import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import AdminUsers from "@/pages/admin/AdminUsers";
import AuditTrail from "@/pages/admin/AuditTrail";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public */}
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/courses" element={<PublicCatalog />} />
            <Route path="/verify" element={<VerifyPortal />} />
            <Route path="/verify/:hash" element={<VerifyPortal />} />

            {/* Student */}
            <Route
              path="/app/student"
              element={
                <ProtectedRoute roles={["student"]}>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<StudentOverview />} />
              <Route path="courses" element={<StudentCourses />} />
              <Route path="catalog" element={<Catalog />} />
              <Route path="certificates" element={<StudentCertificates />} />
              <Route path="wallet" element={<WalletPage />} />
              <Route path="tutor" element={<TutorPage />} />
              <Route path="rewards" element={<RewardsPage />} />
              <Route path="store" element={<StorePage />} />
              <Route path="leaderboard" element={<LeaderboardPage />} />
              <Route path="learn/:courseId" element={<LessonPlayer />} />
            </Route>

            {/* Teacher */}
            <Route
              path="/app/teacher"
              element={
                <ProtectedRoute roles={["teacher"]}>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<TeacherOverview />} />
              <Route path="gradebook" element={<Gradebook />} />
              <Route path="catalog" element={<Catalog />} />
              <Route path="rewards" element={<RewardsPage />} />
              <Route path="store" element={<StorePage />} />
            </Route>

            {/* Admin */}
            <Route
              path="/app/admin"
              element={
                <ProtectedRoute roles={["admin"]}>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminAnalytics />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="audit" element={<AuditTrail />} />
              <Route path="catalog" element={<Catalog />} />
              <Route path="rewards" element={<RewardsPage />} />
              <Route path="store" element={<StorePage />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

function PublicCatalog() {
  return (
    <div className="min-h-screen bg-background">
      <Catalog />
    </div>
  );
}

export default App;
